export default "__VITE_ASSET__InWJOgt7__"